import axios from "axios";

import Errors from './Errors'
import defaultData from './defaultFormData'
class Form {
    // busy : boolean;
    // originalData:object;
    // errors:Errors;
    // submitting:boolean;
    // submitText:string;
    // billing_address:{
    //     street:string,
    //     city:string;
    //     state:string;
    //     zip:string
    // };
    // home_address:{
    //     street:string,
    //     city:string;
    //     state:string;
    //     zip:string
    // };

    // constructor(data:object){
    constructor(data){
        this.busy = false;
        this.cacheCompatibilityEnabled = false;
        this.originalData = Object.assign({}, data);
        for(let field in data){
            this[field] = data[field];
        }
        this.errors = new Errors();
        this.submitting = false;
        this.submitText = 'Place Order';
        this.billing_address = {
            street: '',
            city: '',
            state: '',
            zip: ''
        }
        this.home_address = {
            street: '',
            city: '',
            state: '',
            zip: ''
        }
        this.card = Object.assign({}, data.card);
        this.products = [];
        this.setProducts = this.setProducts.bind(this);
    }

    isBusy(){
        return this.busy === true || this.submitting === true;
    }

    reset(){
        for (let field in defaultData){
            this[field] = {};
        }
    }

    setCacheCompatibilityEnabled(setting)
    {
        this.cacheCompatibilityEnabled = setting;
    }

    setProducts(products){
        this.products = products;
    }

    getProducts()
    {
        return this.products;
    }

    data() {
        let data = Object.assign({}, this);
        if (this.cacheCompatibilityEnabled) {
            data.product_ids = [].concat(this.getProducts().map(product => {
                return product.id();
            }));
        } else {
            delete data.products;
        }
        delete data.originalData;
        delete data.errors;
        return data;
    }

    setBillingAddress(){
        this.billing_address.street = this.home_address.street;
        this.billing_address.city = this.home_address.city;
        this.billing_address.state = this.home_address.state;
        this.billing_address.zip = this.home_address.zip;
    }

    submit(method, url){
    // submit(method:string, url:string){
        this.busy = true;
        this.submitting = true;
        return new Promise((resolve, reject) => {
            axios[method](url, this.data())
                .then(response => {
                    this.onSuccess(response.data)
                    resolve(response.data)
                })
                .catch(error => {
                    this.busy = false;
                    this.submitting = false;
                    this.onFail(error.response.data);
                    reject(error.response.data)
                })
        });
    }

    onSuccess(data) {
        this.submitting = false;
        this.submitText = 'Place Order';
    }

    onFail(errors){
        this.submitting = false;
        this.submitText = 'Place Order';
        if (errors.hasOwnProperty('data')) {
            this.errors.record(errors.data)
            this.errors.modal.open = true;
        }
    }
}

export default Form;
